import { render, staticRenderFns } from "./BattlesCreate.vue?vue&type=template&id=68a97028&scoped=true"
import script from "./BattlesCreate.vue?vue&type=script&lang=js"
export * from "./BattlesCreate.vue?vue&type=script&lang=js"
import style0 from "./BattlesCreate.vue?vue&type=style&index=0&id=68a97028&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a97028",
  null
  
)

export default component.exports